import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { isNullOrUndefined } from 'util';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faExclamationTriangle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import './SimpleModal.css';
const headerIcon = {
    scb : <FontAwesomeIcon size="lg" icon={faInfoCircle}/>,
    danger : <FontAwesomeIcon size="lg" icon={faExclamationTriangle}/>,
    warning : <FontAwesomeIcon size="lg" icon={faExclamationTriangle}/>,
    success : <FontAwesomeIcon size="lg" icon={faCheckCircle}/>,
    primary : <FontAwesomeIcon size="lg" icon={faInfoCircle}/>
}

const SimpleModal = (props) => {
    const {modal, onClose} = props;
    const modalStyle = isNullOrUndefined(modal.variant) ? "scb" : modal.variant;
    return (
        <Modal show={modal.show} onHide={onClose} backdrop={modal.backdrop ? modal.backdrop : true}> 
            <Modal.Header closeButton={modal.backdrop==='static' ? false : true}>
                <Modal.Title className={"text-" + modalStyle}>
                    {headerIcon[modalStyle]} {modal.header}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="modal-fixed-height">
                {modal.body}
            </Modal.Body>

            {modal.footer ?
            <Modal.Footer>
                {modal.footer}
            </Modal.Footer>
            :
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={onClose}>Close</Button>
            </Modal.Footer>
            }
        </Modal>
    );
}
export default SimpleModal;